$(function () {
  $('.card__information .card__heading.h5').matchHeight();
})

// Product Description

document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".product__description.rte.quick-add-hidden");


  // Check if content is overflowing
  if (description.scrollHeight > description.clientHeight) {

    var descriptionMAn = document.querySelector(".product__description.rte.quick-add-hidden");

    var descrptionClosest = descriptionMAn.closest('.quantity--with__buy-button');

    // Create the button
    const button = document.createElement("button");
    button.classList.add("pdp-read-more-btn");
    button.textContent = "Read More...";

    $('.quantity--with__buy-button').before(button);

    // descrptionClosest.append(button);

    $(descrptionClosest).before(button);

    // Toggle functionality
    button.addEventListener("click", function () {
      description.classList.toggle("expanded");
      button.textContent = description.classList.contains("expanded") ? "Read Less..." : "Read More....";
    });
  }
});

//removeExpiredEvents

removeExpiredEvents();

function removeExpiredEvents() {
  if (localStorage.getItem("uniqueEventShare")) {
    // Retrieve the stored object from localStorage
    const storedObject = JSON.parse(localStorage.getItem("uniqueEventShare"));
    //console.log("Retrieved JSON object from localStorage:", storedObject);
    // Get the current UTC date
    const currentDate = new Date();
    // Filter out events that have an expired endDate
    const updatedObject = storedObject.map(item => {
      // Filter the events array by checking if the endDate is greater than the current date
      const validEvents = item.event.filter(event => new Date(event.endDate) > currentDate);

      // If there are valid events left, return the updated item, else return null (for deletion)
      if (validEvents.length > 0) {
        return {
          ...item,
          event: validEvents
        };
      } else {
        return null; // Remove this vol entry if no valid events
      }
    }).filter(item => item !== null); // Remove any null entries (those with no valid events)

    // Store the updated object back into localStorage
    localStorage.setItem("uniqueEventShare", JSON.stringify(updatedObject));

    console.log("Updated JSON object after removing expired events:", updatedObject);
  }
}

// List view and grid view

document.addEventListener('DOMContentLoaded', function() {
  const listViewBtn = document.getElementById('list-view');
  const gridViewBtn = document.getElementById('grid-view');
  const productGrid = document.querySelector('.product-grid');

  // Load saved preference
  const savedView = localStorage.getItem('collectionView') || 'grid';
  setView(savedView);

  // List view button click handler
  listViewBtn.addEventListener('click', () => {
    setView('list');
  });

  // Grid view button click handler
  gridViewBtn.addEventListener('click', () => {
    setView('grid');
  });

  function setView(view) {
    // Update buttons
    listViewBtn.classList.toggle('active', view === 'list');
    gridViewBtn.classList.toggle('active', view === 'grid');

    // Update grid
    if (view === 'list') {
      productGrid.classList.add('list-view');
    } else {
      productGrid.classList.remove('list-view');
    }

    // Save preference
    localStorage.setItem('collectionView', view);
  }

  
});


// $(document).ready(function () {
//   // if (sessionStorage.getItem('refreshAccount') === 'true') {
//   //     sessionStorage.removeItem('refreshAccount'); // Remove the flag after refresh
//   //     setTimeout(function () {
//   //         location.reload();
//   //     }, 500); // Adjust delay if needed
//   // }

//   if (sessionStorage.getItem('newRegister') === 'true') {
   
//     setTimeout(function () {
//       $('.form-step[data-step="5"] button.btn-next').hide();

//           }, 500);

//   }
// });



  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const storeCode = params.get('code');

    const storeInfocart = document.querySelector('.drawer__inner .product__default-store-info');
    const storeInfoPdp = document.querySelector('.product__info-wrapper .product__default-store-info');

    if (storeCode === 'IQ89RZ-Q08') {
      if (storeInfocart) storeInfocart.classList.add('active');
      if (storeInfoPdp) storeInfoPdp.classList.add('active');
    } else {
      if (storeInfocart) storeInfocart.classList.remove('active');
      if (storeInfoPdp) storeInfoPdp.classList.remove('active');
    }
  });

  // Smooth scroll to anchor on page load
window.addEventListener('load', () => {
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }
});




